import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { loadEffect, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { record_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { stackClasses, DateTimeOffsetExtensions_toDateHHmmss, formatUrl, Locale_get_FromSelectedLanguage } from "../../Utils.js";
import * as react from "react";
import { loadFileImport as loadFileImport_1 } from "./Api.js";
import { renderLoadState } from "../../Components/Misc/Misc.js";
import { renderCustomTable, Elements_renderCell, Elements_renderHeader } from "../../Components/Table/Table.js";
import { singleton, map, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { RouterModule_nav, RouterModule_urlSegments, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { uncurry, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { UTC__toDateTimeOffset } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { renderFileImportState } from "./Common.js";
import { error } from "../../Redux/Reducers/ModalsReducer.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { Page$reflection } from "./Model.js";
import { DetailsProps, view as view_1 } from "./Details/View.js";
import "../../../src/Containers/FileImport/View.scss";


class FileImportTableProps extends Record {
    constructor(GlobalDependencies) {
        super();
        this.GlobalDependencies = GlobalDependencies;
    }
}

function FileImportTableProps$reflection() {
    return record_type("Containers.FileImport.View.FileImportTableProps", [], FileImportTableProps, () => [["GlobalDependencies", GlobalDependencies$reflection()]]);
}

const fileImportTable = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const reduxDispatch = useDispatch();
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const fileImportLoadState = react.useState(new LoadState$2(0));
    react.useEffect(() => {
        loadEffect(() => loadFileImport_1(props.GlobalDependencies.ClientNr), (arg) => {
            fileImportLoadState[1](arg);
        });
    }, [props.GlobalDependencies]);
    const children_6 = [(children_4 = [getTranslation("Import.ImportProgram.FileImport")], react.createElement("h1", {}, ...children_4)), renderLoadState((fileImports) => {
        const headers = ofArray([Elements_renderHeader(getTranslation("Import.ImportProgram.FileName")), Elements_renderHeader(getTranslation("Import.ImportProgram.CreatedAtUtc")), Elements_renderHeader(getTranslation("Import.ImportProgram.ParsedAtUtc")), Elements_renderHeader(getTranslation("Import.ImportProgram.Status")), Elements_renderHeader("")]);
        const rows = map((fileImport) => {
            let props_1, children;
            const url = RouterModule_encodeParts(formatUrl(RouterModule_urlSegments(window.location.hash, 1), singleton("FileImport"), singleton(int32ToString(fileImport.BulkImportId))), 1);
            const children_2 = [Elements_renderCell(fileImport.BulkImportName), Elements_renderCell(DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTimeOffset(fileImport.CreatedAtUtc))), Elements_renderCell(defaultArg(map_1((utc) => DateTimeOffsetExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTimeOffset(utc)), fileImport.ParsedAtUtc), "")), Elements_renderCell(renderFileImportState((msg) => {
                reduxDispatch(error(msg));
            }, locale, fileImport)), (props_1 = [new HTMLAttr(65, stackClasses(ofArray(["cell", "d-flex", "justify-content-end"])))], (children = [wrappedButton(new ButtonKind(1), new ButtonProps(getTranslation("Import.ImportProgram.SeeDetails"), defaultProps.Content, (_arg) => {
                RouterModule_nav(singleton(url), 1, 1);
            }, defaultProps.Disabled, `${fileImport.BulkImportName}-see-details-btn`, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("td", keyValueList(props_1, 1), ...children)))];
            return react.createElement("tr", {}, ...children_2);
        }, fileImports);
        return Pagination()(new PageinationProps$1((rows_1) => renderCustomTable(headers, rows_1), rows, 10, 0));
    }, fileImportLoadState[0])];
    return react.createElement("div", {
        className: "file-import",
    }, ...children_6);
}, "FileImportTable", uncurry(2, void 0), void 0, "fileImportTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FileImport\\View.fs", 99);

export class FileImportProps extends Record {
    constructor(GlobalDependencies, Page) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.Page = Page;
    }
}

export function FileImportProps$reflection() {
    return record_type("Containers.FileImport.View.FileImportProps", [], FileImportProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["Page", Page$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const matchValue = props.Page;
    switch (matchValue.tag) {
        case 1: {
            return view_1(new DetailsProps(props.GlobalDependencies, matchValue.fields[0]));
        }
        case 2: {
            const children_2 = [(children = [getTranslationFrom(translationsLoadState, "Common.NotFound")], react.createElement("h3", {}, ...children))];
            return react.createElement("div", {}, ...children_2);
        }
        default: {
            return fileImportTable(new FileImportTableProps(props.GlobalDependencies));
        }
    }
}, "FileImport", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FileImport\\View.fs", 116);

